import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const OOPS_M1_DAG_BasicBlocks_MachineIndepOpt = () => (
  <QPhototModuleSubtopic
    title="The DAG Representation of Basic Blocks - Loops in Flow Graphs - Machine Independent Optimization"
    videos={[
      "https://www.youtube.com/embed/fAjIlKmCuUY",
      "https://www.youtube.com/embed/E8Q43xSNx6Q",
      "https://www.youtube.com/embed/MV0mKgT7PuY",
    ]}
    takeaways={[]}
    questions={[
      {
        text: "What are the sources of redundancy in the given graph? What are the properties of natural loops? (refer to the given fig.) Do data flow analysis in the given flow graph? Answers to the following questions by referring to the given fig. a) Find the dominator relation b) Find the immediate dominator of each node. c) Construct the dominator trees d) Find one depth-first ordering of the flow graph. ",
        image: "/CD_1.png",
      },

      {
        text:"Give the DAG representation of the following basic block with three-address code: (1) t1 := 4i, (2) t2 := a[t1], (3) t3 := 4i, (4) t4 := b[t3], (5) t5 := t2t4, (6) t6 := prod + t5, (7) prod := t6, (8) t7 := i+1, (9) t8 := 42, (10) if t8 < 5 goto (4), (11) i := t7, (12) if i <= 20 goto (1); then apply suitable peephole optimizations to generate optimized code."

      },

      {
        text:"Draw the DAG for the expressions x = a + b, y = x + c, z = x * d, identify common subexpressions, and explain how the DAG helps in code optimization"
      },

      {
        text:"Construct the DAG and identify the value numbers for the sub-expressions of the following expressions, assuming + associates from the left. i) a*b +(a*b) ii) a*b*a*b "
      },
      {
        text:"Given a function with integer variables and input parameters p and n, analyze the code fragment to determine (i) the Data Flow Graph (DFG), (ii) the dominator tree and loops (with back edges), (iii) perform constant propagation within the loop body, and (iv) check if statements at lines 8 and 16 are loop invariants and where they can be moved if applicable."
      }
      
     
    ]}
    exampleVideos={[]}
  />
);

export default OOPS_M1_DAG_BasicBlocks_MachineIndepOpt;
